import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ReducerConstants from '../../../_shared/constants/reducers';
import { Dealer } from './state';

const setOrganizationDealerDetails = (
  state,
  action: PayloadAction<Dealer>
) => ({
  ...state,
  ...action.payload
});

export const organizationSlice = createSlice({
  name: ReducerConstants.ORGANIZATION_DEALER,
  initialState: {}, // TODO: Update with Dealer empty model
  reducers: {
    setOrganizationDealerDetails
  }
});

export default organizationSlice.reducer;
